// extracted by mini-css-extract-plugin
module.exports = {"claimButton":"ClaimButton_claimButton__EA_RU","helpBtn":"ClaimButton_helpBtn__35yR2","toolTip":"ClaimButton_toolTip__11OJL","toolTipText":"ClaimButton_toolTipText__1X9PH"};